import React, { useEffect, useState, useRef } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { apiGet } from '../api/client';
import type { TermsAndConditionsResponse } from '../types/api';
import LoadingSpinner from '../components/LoadingSpinner';

export default function RequireTerms() {
  const [checking, setChecking] = useState(true);
  // undefined = still checking; null = no pending terms; object = must accept
  const [pendingTerms, setPendingTerms] = useState<TermsAndConditionsResponse | null | undefined>(undefined);
  const called = useRef(false);

  useEffect(() => {
    if (called.current) return;
    called.current = true;

    (async () => {
      try {
        // Returns T&C object on 200, undefined on 204 (already up to date)
        const terms = await apiGet<TermsAndConditionsResponse | undefined>('/api/terms/pending');
        setPendingTerms(terms ?? null);
      } catch {
        // On any error, don't block the user — let them through
        setPendingTerms(null);
      } finally {
        setChecking(false);
      }
    })();
  }, []);

  if (checking) {
    return <LoadingSpinner fullPage />;
  }

  if (pendingTerms) {
    return <Navigate to="/re-accept-terms" replace />;
  }

  return <Outlet />;
}
